import Api from '../index'

let path = '/transactions'

async function get(params) {
    const queryParams = new URLSearchParams(params).toString();
    console.log(queryParams);
    return Api.get(path + '?' + queryParams)
}

async function post(input) {
    return Api.postResponse(path, input)
}

async function remove(id) {
    return Api.remove(path + '/' + id)
}

function put(id, input) {
    return Api.put(path + '/' + id, input)
}

export default {
    get: get,
    post: post,
    remove: remove,
    put: put
}
